{
  "translation": {
    "copyright": "© {{year}} The Savings Group, Inc.",
    "currency": {
      "aMonth": "${{amount}}/mes"
    },
    "disclosures": {
      "alimony": "La pensión alimenticia, la manutención infantil o los ingresos por manutención por separado no necesitan ser revelados si no deseas que se consideren como base para pagar esta obligación.",
      "applicantIncome": "Estos deben ser tus ingresos brutos anuales de tu trabajo, inversiones, pensiones y/o beneficios del gobierno, todo antes de cualquier deducción de impuestos federales y estatales y antes de cualquier otra deducción de nómina. La mayoría de los prestamistas requieren un mínimo de $24,000 de ingresos anuales totales. Llama al <phone>{{phoneNumber}}</phone> si tienes preguntas sobre tu situación específica.",
      "coapplicantIncome": "Estos deben ser sus ingresos brutos anuales de su trabajo, inversiones, pensiones y/o beneficios del gobierno, todo antes de cualquier deducción de impuestos federales y estatales y antes de cualquier otra deducción de nómina. La mayoría de los prestamistas requieren un mínimo de $24,000 de ingresos anuales totales. Llama al <phone>{{phoneNumber}}</phone> si tienes preguntas sobre su situación específica.",
      "creditReportAcknowledgement": "Al submitir esta aplicación, reconoces que has leído y aceptas nuestros <terms>Términos de uso</terms> y nuestra <privacy>Póliza de privacidad</privacy>; que tienes al menos 18 años de edad y que toda la información proporcionada es verdadera, correcta y completa, y otorgas permiso a {{brand}} y/o sus prestamistas para obtener una copia de tu informe de crédito.",
      "jointCredit": "Al seleccionar agregar un co-prestatario, ambos indican su intención de solicitar crédito conjuntamente. No selecciones el campo de co-prestatario a menos que desees solicitar crédito conjunto.",
      "prequalAuthorization": "Entiendes que al marcar esta casilla estás proporcionando instrucciones por escrito conforme a la Ley de Informes Justos de Crédito (Fair Credit Reporting Act) autorizando a {{brand}} y a sus prestamistas participantes a obtener mi perfil de crédito personal y otra información de las agencias de informes de crédito únicamente para las opciones de precalificación de crédito.",
      "smsOptIn": "Al marcar esta casilla, acepta recibir mensajes SMS transaccionales de {{brand}} sobre el estado de su solicitud de préstamo al número de teléfono proporcionado. La frecuencia de los mensajes varía según la actividad de la solicitud. Pueden aplicarse tarifas de mensajes y datos. Envíe STOP para optar por no participar. Responda HELP para obtener ayuda.",
      "termsPrivacy": "Al registrarse, acepta nuestros <terms>Términos de uso</terms> y <privacy>Póliza de privacidad.</privacy>",
      "termsPrivacyReceipt": "Al registrarse, acepta nuestros <terms>Términos de uso</terms> y acusa recibo de nuestra <privacy>Póliza de privacidad.</privacy>"
    },
    "validation": {
      "phone": {
        "required": "Se requiere teléfono",
        "invalid": "Por favor ingrese un número de teléfono válido",
        "applicantConflict": "No puede ser el mismo número de teléfono que el del aplicante"
      },
      "firstName": {
        "required": "Se requiere el primer nombre",
        "minLength": "Debe tener al menos {{min}} letras",
        "invalid": "Solo debe contener letras, espacios, apóstrofes y guiones."
      },
      "lastName": {
        "required": "Se requiere el apellido",
        "minLength": "Debe tener al menos {{min}} letras",
        "invalid": "Solo debe contener letras, espacios, apóstrofes y guiones."
      },
      "emailAddress": {
        "required": "Se requiere el correo electronico",
        "invalid": "Por favor ingrese un correo electrónico válido",
        "applicantConflict": "No puede ser el mismo correo electrónico que el del aplicante"
      },
      "vin": {
        "invalidCharacters": "El VIN solo debe contener números y letras mayúsculas, excluyendo las letras \"I\", \"O\" y \"Q\".",
        "required": "Se requiere el VIN"
      },
      "plate": {
        "required": "Se requiere la placa"
      },
      "state": {
        "required": "Se requiere el estado"
      },
      "year": {
        "required": "El año es obligatorio"
      },
      "make": {
        "required": "La marca es obligatoria"
      },
      "model": {
        "required": "El modelo es obligatorio"
      },
      "trim": {
        "required": "Se requiere la versión"
      },
      "mileage": {
        "required": "Se requiere el millaje",
        "invalid": "Por favor ingrese un número valido"
      },
      "payoffAmount": {
        "required": "Se requiere el pago restante",
        "min": "Debe ser un valor mayor que {{min}}",
        "max": "Debe ser un valor menor que {{max}}"
      },
      "purchasePrice": {
        "required": "Se requiere el precio de compra",
        "min": "Debe ser un valor mayor que {{min}}",
        "max": "Debe ser un valor menor que {{max}}"
      },
      "housingAmount": {
        "required": "Se requiere la cantidad de vivienda",
        "min": "Debe ser un valor mayor o igual a {{min}}",
        "max": "Debe ser un valor menor que {{max}}"
      },
      "address": {
        "required": "Se requiere la dirección"
      },
      "city": {
        "required": "Se requiere la ciudad"
      },
      "zipCode": {
        "required": "Se requiere el código postal",
        "minMax": "Debe tener {{minMax}} dígitos"
      },
      "employerName": {
        "required": "Se requiere el nombre del empleador"
      },
      "jobTitle": {
        "required": "Se requiere el título profesional"
      },
      "durationMonths": {
        "required": "Se requiere los meses de duración"
      },
      "durationYears": {
        "required": "Se requiere los años de duración"
      },
      "grossAnnualIncome": {
        "required": "Se requiere el ingreso anual bruto",
        "min": "Debe ser un valor mayor o igual a {{min}}"
      },
      "employmentType": {
        "required": "Se requiere el tipo de empleo"
      },
      "incomeType": {
        "required": "Se requiere el tipo de ingreso"
      },
      "incomeFrequency": {
        "required": "Se requiere la frecuencia de ingreso"
      },
      "incomeAmount": {
        "required": "Se requiere la cantidad de ingreso",
        "min": "Debe ser un valor mayor o igual a {{min}}"
      },
      "additionalIncome": {
        "required": "Se requiere los ingresos adicionales"
      },
      "dateOfBirth": {
        "required": "Se requiere la fecha de nacimiento",
        "invalid": "Por favor, ingresa una fecha de nacimiento válida",
        "futureDate": "La fecha de nacimiento debe ser una fecha pasada"
      },
      "ssn": {
        "required": "Se requiere el número de seguro social",
        "invalid": "Por favor, ingresa un número de seguro social válido"
      },
      "terms": {
        "required": "Se requiere aceptar los términos de uso y la póliza de privacidad"
      },
      "prequalDisclosure": {
        "required": "Se requiere aceptar la divulgación de precalificación"
      },
      "smsOptIn": {
        "required": "Se requiere aceptar recibir mensajes SMS"
      },
      "file": {
        "formatInvalid": "{{fileName}}: tipo de archivo incorrecto",
        "sizeExceeded": "{{fileName}} es mayor que {{maxFileSize}}"
      },
      "mailCode": {
        "required": "Se requiere el código de ahorros"
      }
    },
    "errors": {
      "parameter": {
        "APPLICATION_KEY_MISSING_OR_EXPIRED": "El enlace de activación ha expirado. Por favor, inicia sesión para continuar.",
        "INVALID_APPLICATION_KEY": "Se proporcionó un enlace de activación no válido. Por favor, inicia sesión para continuar.",
        "INVALID_AUTHORIZATION_CODE": "No pudimos completar tu inicio de sesión automáticamente. Ingresa tu número de teléfono a continuación para continuar.",
        "INVALID_RATE_SELECTED": "Selección de tasa no válida. Por favor, inicia sesión para continuar.",
        "LOS_IMPORT_ERROR": "Por favor, inicia sesión para activar tu aplicación.",
        "MISSING_APPLICATION_KEY": "No se pudo encontrar tu enlace de activación. Por favor, inicia sesión para intentarlo de nuevo.",
        "MISSING_AUTHORIZATION_CODE": "No pudimos completar tu inicio de sesión automáticamente. Ingresa tu número de teléfono a continuación para continuar.",
        "MISSING_ENCODED_DATA": "No pudimos encontrarte en nuestro sistema. Por favor, inicia sesión para continuar.",
        "TOO_MANY_REQUESTS": "No pudimos iniciar tu sesión automáticamente porque hubo demasiados intentos. Espera unos minutos y luego ingresa tu número de teléfono a continuación para continuar."
      },
      "deliverPin": {
        "statusMessage": {
          "403": "Su cuenta ha sido bloqueada temporalmente",
          "404": "No se encontró una cuenta que pertenece a este número de teléfono. Por favor <signup>regístrese</signup>",
          "409": "Se encontró una cuenta perteneciente a este número de teléfono. Por favor <signin>inicia sesión</signin>",
          "422": "Por favor verifique su número de teléfono",
          "429": "Demasiados intentos. Espere unos minutos e inténtelo de nuevo."
        },
        "errorCode": {
          "ACCOUNT_OWNERSHIP_UNVERIFIED": "Ya hay una cuenta registrada con este correo electrónico. Por su seguridad, inicie sesión con el número de teléfono de esa cuenta.",
          "SMS_DELIVERY_UNKNOWN": "Se envió tu mensaje, pero no podemos confirmar la entrega. Verifica que tu número sea correcto.",
          "SMS_INVALID_NUMBER": "El número de teléfono ingresado no parece ser válido. Por favor verifica y actualiza tu número.",
          "SMS_LANDLINE": "Este número parece ser una línea fija o no es accesible. Por favor proporciona un número móvil para recibir mensajes.",
          "SMS_REGION_NOT_ENABLED": "No podemos enviar mensajes a la región de este número de teléfono. Comunícate con soporte para recibir asistencia.",
          "SMS_UNKNOWN_DESTINATION": "No pudimos comunicarnos con este número de teléfono. Verifica que sea correcto e inténtalo de nuevo.",
          "SMS_UNKNOWN_ERROR": "Algo salió mal al entregar tu mensaje. Inténtalo de nuevo o comunícate con soporte si el problema persiste.",
          "SMS_UNREACHABLE": "No se pudo entregar tu mensaje. El teléfono puede estar apagado o fuera de cobertura. Lo intentaremos de nuevo en breve.",
          "SMS_UNSUBSCRIBED": "Este número se ha dado de baja previamente. Para volver a suscribirte, responde START o contacta a soporte."
        },
        "defaultMessage": "Se produjo un error inesperado al intentar enviar el código de verificación. Vuelva a intentarlo más tarde."
      },
      "userAuthenticate": {
        "statusMessage": {
          "401": "Codigo invalido. Comprueba el número y vuelve a intentarlo.",
          "403": "Su cuenta alcanzó el número máximo de intentos fallidos de inicio y se bloqueó temporalmente. Inténtelo de nuevo en 15 minutos.",
          "404": "Codigo invalido. Comprueba el número y vuelve a intentarlo.",
          "429": "Demasiados intentos. Espere unos minutos e inténtelo de nuevo.",
          "500": "Se produjo un error al intentar verificar el código. Por favor reenvíelo."
        },
        "errorCode": {
          "ACCOUNT_OWNERSHIP_UNVERIFIED": "No pudimos confirmar que esta cuenta le pertenece. Inicie sesión con el número de teléfono de la cuenta o use el enlace que le enviaron."
        },
        "defaultMessage": "Se produjo un error inesperado al intentar verificar el código. Inténtalo de nuevo."
      },
      "userCreate": {
        "statusMessage": {
          "401": "Codigo invalido. Comprueba el número y vuelve a intentarlo.",
          "403": "Demasiados códigos incorrectos. Este número de teléfono se bloqueó temporalmente. Inténtelo de nuevo en 15 minutos.",
          "404": "Codigo invalido. Comprueba el número y vuelve a intentarlo.",
          "429": "Demasiados intentos. Espere unos minutos e inténtelo de nuevo.",
          "500": "Se produjo un error al intentar verificar el código. Por favor reenvíelo."
        },
        "defaultMessage": "Se produjo un error inesperado al intentar verificar el código. Inténtalo de nuevo."
      },
      "userExists": {
        "statusMessage": {
          "429": "Demasiados intentos. Espere unos minutos e inténtelo de nuevo."
        }
      },
      "userUpdate": {
        "defaultMessage": "No se puede realizar la solicitud. Por favor, inténtelo de nuevo más tarde."
      },
      "fetchVehicleBy": {
        "statusMessage": {
          "404": "No se encontraron detalles del vehículo"
        },
        "defaultMessage": "No se puede realizar la solicitud. Por favor, inténtelo de nuevo más tarde."
      },
      "fetchVehicleMakes": {
        "defaultMessage": "No se puede realizar la solicitud. Por favor, inténtelo de nuevo más tarde."
      },
      "fetchVehicleModels": {
        "defaultMessage": "No se puede realizar la solicitud. Por favor, inténtelo de nuevo más tarde."
      },
      "fetchVehicleTrims": {
        "defaultMessage": "No se puede realizar la solicitud. Por favor, inténtelo de nuevo más tarde."
      },
      "apply": {
        "defaultMessage": "No se puede realizar la solicitud. Por favor, inténtelo de nuevo más tarde.",
        "statusMessage": {
          "409": "Parece que ya tienes una aplicación activa para este vehículo. <dashboard>Haga clic aquí para resumir.</dashboard>"
        }
      },
      "fetchVehicles": {
        "defaultMessage": "Se produjo un error inesperado al intentar buscar vehículos. Por favor, inténtelo de nuevo más tarde."
      },
      "fetchVehicleByApplicationAutopayNumber": {
        "defaultMessage": "Se produjo un error inesperado al intentar buscar el vehículo. Por favor, inténtelo de nuevo más tarde."
      },
      "fetchVehicleById": {
        "defaultMessage": "Se produjo un error inesperado al intentar buscar el vehículo. Por favor, inténtelo de nuevo más tarde."
      },
      "syncIncome": {
        "defaultMessage": "No se puede realizar la solicitud. Por favor, inténtelo de nuevo más tarde."
      },
      "syncResidence": {
        "defaultMessage": "No se puede realizar la solicitud. Por favor, inténtelo de nuevo más tarde."
      },
      "submitApplication": {
        "defaultMessage": "Se produjo un error inesperado. Por favor, inténtelo de nuevo más tarde.",
        "dateOfBirthInvalidMessage": "Se proporcionó una fecha de nacimiento no válida. Por favor, corríjala y intente de nuevo.",
        "statusMessage": {
          "409": "Nuestros registros indican que ya has enviado esta aplicación. Por favor, revisa tu panel para ver los siguientes pasos."
        }
      },
      "createCoapplicant": {
        "defaultMessage": "No se puede realizar la solicitud. Por favor, inténtelo de nuevo más tarde."
      },
      "syncCoapplicant": {
        "defaultMessage": "No se puede realizar la solicitud. Por favor, inténtelo de nuevo más tarde."
      },
      "disableCoapplicant": {
        "defaultMessage": "No se puede realizar la solicitud. Por favor, inténtelo de nuevo más tarde."
      },
      "updateVehicle": {
        "defaultMessage": "No se puede realizar la solicitud. Por favor, inténtelo de nuevo más tarde."
      },
      "retryFailedSubmission": {
        "defaultMessage": "No se puede realizar la solicitud. Por favor, inténtelo de nuevo más tarde."
      },
      "fetchMailCode": {
        "statusMessage": {
          "404": "El código de ahorros no es válido. Por favor, revise su correo electrónico e inténtelo de nuevo.",
          "429": "Demasiados intentos. Espere unos minutos e inténtelo de nuevo."
        },
        "defaultMessage": "Se produjo un error inesperado al intentar obtener su oferta. Por favor, inténtelo de nuevo más tarde."
      }
    },
    "imageAlts": {
      "logo": "The Savings Group",
      "menu": "Alternar menú",
      "heroErrorWithSmoke": "Ilustración de una persona usando una computadora de la que sale humo",
      "heroReference": "Ilustración de una persona que sostiene un teléfono y recibe un mensaje SMS para iniciar sesión en su cuenta",
      "heroSearching": "Ilustración de una persona que sostiene un telescopio en busca de un mejor préstamo para automóvil",
      "heroWithCamera": "Ilustración de una persona tomándose un autorretrato con una cámara.",
      "heroesCheering": "Ilustración de personas celebrando y aplaudiendo",
      "selectedVehicle": "Vehículo seleccionado para financiación",
      "applicationVehicle": "Vehículo que le pertenece a la aplicación",
      "heroSuccess": "Ilustración de una persona",
      "heroMeditation": "Ilustración de una persona meditando",
      "heroDesigner": "Ilustración de una persona diseñando en una computadora.",
      "vehicleSUVSideView": "Vista lateral de un vehículo todoterreno",
      "vehicleSUVTopView": "Vista superior de un vehículo todoterreno",
      "reviews": "Reseñas confiables de clientes en Google"
    },
    "verificationStatus": {
      "complete": "Completo",
      "optional": "Opcional",
      "requested": "Solicitado"
    },
    "verifications": {
      "applicantDriversLicense": {
        "name": "Licencia de conducir del aplicante",
        "headline": "Suba la licencia de conducir",
        "copy": "Por favor, suba una foto clara o copia de la licencia de conducir estatal del aplicante. Asegúrese de que sea válida y esté actualizada."
      },
      "coapplicantDriversLicense": {
        "name": "Licencia de conducir del co-aplicante",
        "headline": "Suba la licencia de conducir del co-aplicante",
        "copy": "Por favor, suba una foto clara o copia de la licencia de conducir estatal del co-aplicante. Asegúrese de que sea válida y esté actualizada."
      },
      "proofOfAutoInsurance": {
        "name": "Prueba de seguro de automóvil",
        "headline": "Prueba de seguro de automóvil",
        "copy": "Por favor, proporcione una foto clara del prueba de seguro de su vehículo. Estos documentos deben ser válidos y estar actualizados."
      },
      "registrationCard": {
        "name": "Tarjeta de registración",
        "headline": "Suba la tarjeta de registración",
        "copy": "Por favor, proporcione una foto clara de la tarjeta de registración de su vehículo. Estos documentos deben ser válidos y estar actualizados."
      },
      "photoOfOdometer": {
        "name": "Foto del odómetro",
        "headline": "Suba la foto del odómetro",
        "copy": "Por favor, proporcione una foto clara de la lectura actual del odómetro de su vehículo tal como aparece en el vehículo."
      },
      "proofOfIncome": {
        "name": "Prueba de ingresos",
        "headline": "Suba la prueba de ingresos",
        "copy": "Por favor, proporcione una foto clara del comprobante de pago más reciente del aplicante. Estos documentos deben ser válidos y estar actualizados."
      },
      "coapplicantProofOfIncome": {
        "name": "Prueba de ingresos del co-aplicante",
        "headline": "Suba la prueba de ingresos del co-aplicante",
        "copy": "Por favor, proporcione una foto clara del comprobante de pago más reciente del co-aplicante. Estos documentos deben ser válidos y estar actualizados."
      }
    },
    "additionalDocuments": {
      "name": "Documentos adicionales",
      "headline": "Suba la licencia de conducir",
      "copy": "Por favor, use esto para subir cualquier documento adicional solicitado por su especialista en préstamos."
    },
    "files": {
      "frontOfLicense": "Frente de la licencia",
      "backOfLicense": "Reverso de la licencia",
      "proofOfAutoInsurance": "Prueba de seguro de automóvil",
      "registrationCard": "Tarjeta de registración",
      "photoOfOdometer": "Foto del odómetro",
      "mostRecentPaystub": "Comprobante de pago más reciente",
      "additionalDocument": "Documento adicional"
    },
    "tasks": {
      "applicant": {
        "title": "Ayúdanos con cualquier información faltante en tu aplicación",
        "description": "Ayúdanos a finalizar cualquier información faltante sobre ti y tu situación financiera. Necesitaremos esta información para procesar tu aplicación con precisión.",
        "actionTitle": "Resumir aplicación"
      },
      "verifications": {
        "title": "Ahora vamos a subir tus verificaciones requeridas",
        "description": "Tu aplicación está actualmente en revisión y se tomará una decisión pronto. Para agilizar el proceso, continúa subiendo tus documentos de verificación.",
        "actionTitle": "Subir documentos"
      },
      "complete": {
        "title": "Felicidades, parece que estás al día con todo",
        "description": "Has completado todos los requisitos necesarios para que nuestro equipo avance con tu aplicación. Si necesitamos información adicional, nos comunicaremos contigo.",
        "actionTitle": "Volver más tarde"
      },
      "canceled": {
        "title": "Parece que esta aplicación ya no está activa",
        "description": "Tu aplicación ha expirado o ha sido cancelada. Para comenzar una nueva, usa el botón provisto a continuación. Si crees que este mensaje es un error, contáctanos.",
        "actionTitle": "Nueva aplicación"
      },
      "failed": {
        "title": "Algo no esta bien",
        "description": "No pudimos importar su aplicación correctamente. Inténtelo de nuevo y, si el problema persiste, comuníquese con nuestro equipo para obtener ayuda.",
        "actionTitle": "Reintentar"
      },
      "queued": {
        "title": "Estamos trabajando en su aplicación...",
        "description": "Estamos procesando su aplicación y estará lista pronto. Agradecemos su paciencia y le notificaremos en cuanto esté lista.",
        "actionTitle": "Más información"
      },
      "handoff": {
        "title": "Todo listo por ahora",
        "description": "Has completado todo de tu parte. Un miembro del equipo de {{brand}} se pondrá en contacto contigo para guiarte en los próximos pasos y ayudarte a finalizar tu aplicación.",
        "actionTitle": "Contáctanos"
      }
    },
    "applicationDescription": {
      "brand": "{{brand}}",
      "brandWithId": "{{brand}} #{{id}}",
      "inSubmission": "Preparando tu aplicación"
    },
    "applicationProgress": {
      "newApplication": {
        "description": "¡Excelente comienzo! Has dado el primer paso para mejorar tu viaje financiero. Nuestro equipo dedicado está listo para ayudarte en caso de que necesites ayuda durante el proceso.",
        "title": "Nueva aplicación"
      },
      "completeApplication": {
        "description": "Por favor, ayúdanos a completar cualquier información faltante con respecto a tu aplicación de préstamo. Cuando estés listo, la enviaremos a nuestra red de prestamistas para su aprobación.",
        "title": "Aplicación completada"
      },
      "submittedToLender": {
        "description": "El prestamista está revisando tu aplicación y se espera que tome una decisión pronto. Mientras tanto, carga tus documentos de verificación para agilizar el proceso de revisión.",
        "title": "Enviado al prestamista"
      },
      "approvedByLender": {
        "description": "Tu aplicación ha sido aprobada por el prestamista. Asegúrate de completar todas las tareas requeridas para respaldar el avance de tu aplicación.",
        "title": "Aprobado por el prestamista"
      },
      "preparingContracts": {
        "description": "Tu contrato está siendo preparado por nuestro equipo de procesadores. Una vez listo, requeriremos tu firma para finalizar los nuevos términos de refinanciamiento con el prestamista.",
        "title": "Preparando contratos"
      },
      "signingContracts": {
        "description": "¡Estamos listos para ti! Tus contratos han sido preparados y están listos para tu firma. Por favor, revisa y firma la documentación final requerida para finalizar tu nuevo préstamo.",
        "title": "Firmar contratos"
      },
      "reviewingDocuments": {
        "description": "Nuestros procesadores están revisando tus verificaciones actuales. Si hay algo pendiente, es posible que solicitemos elementos de seguimiento antes de obtener una revisión final del prestamista.",
        "title": "Revisando documentos"
      },
      "finalizingStips": {
        "description": "El prestamista ha solicitado información adicional para avanzar en el proceso de aprobación. Por favor, completa cualquier solicitud de información para proceder con tu aprobación.",
        "title": "Finalizar verificaciones"
      },
      "waitingOnFunding": {
        "description": "Tu paquete de préstamo finalizado ha sido enviado al prestamista para su financiamiento. Una vez que tengan la oportunidad de revisarlo, el prestamista volverá con una decisión.",
        "title": "Esperando financiamiento"
      },
      "lenderFunded": {
        "description": "¡Eso es todo! Tu aplicación de préstamo ha sido aprobada y estamos en proceso de trabajar con tu prestamista actual para transferir el saldo pendiente.",
        "title": "Financiado por el prestamista"
      }
    },
    "applicationProgressModal": {
      "applicationProgress": "Progreso de la aplicación",
      "close": "Cerrar"
    },
    "applicationUpdatedModal": {
      "title": "Su aplicación necesita volver a cargarse",
      "content": "Para aplicar las actualizaciones y funciones más recientes, su aplicación debe volver a cargarse. Haga clic en el botón de abajo para actualizar y continuar usando la aplicación con las últimas mejoras.",
      "reloadPage": "Recargar página"
    },
    "applicationQueuedLearnModal": {
      "title": "Estamos trabajando en tu aplicación",
      "content": "En algunos casos, finalizar una aplicación puede tomar un poco más de tiempo (por lo general, solo unos minutos). Cuando esté lista, te mostraremos claramente los siguientes pasos. Si parece que el proceso está tardando más de lo esperado, no dudes en comunicarte con nuestro. Estamos aquí para ayudarte!",
      "close": "Cerrar"
    },
    "navigation": {
      "garage": "Garaje",
      "account": "Cuenta",
      "signout": "Cerrar sesión"
    },
    "additionalIncome": {
      "yes": "Si",
      "no": "No"
    },
    "incomeFrequency": {
      "annually": "Anual",
      "monthly": "Mensual",
      "semiMonthly": "Semanalmente",
      "biWeekly": "Quincenal",
      "weekly": "Semanal"
    },
    "incomeStatus": {
      "hasAdditionalIncome": "Tiene ingresos adicionales",
      "noAdditionalIncome": "No tiene ingresos adicionales"
    },
    "incomeType": {
      "aidForDependentChildren": "Ayuda para hijos dependientes",
      "childSupport": "Manutención de hijos",
      "costOfLivingAllowance": "Subsidio de coste de vida",
      "disability": "Disabilidad",
      "employment": "Empleo",
      "militaryBasicAllowanceForSubsistence": "Subsidio básico militar para subsistencia",
      "munincipalBondInterest": "Interés de bonos municipales",
      "nonTaxableSources": "Fuentes no tributables",
      "other": "Otro",
      "publicAssistance": "Asistencia pública",
      "rentalIncome": "Ingreso por alquiler",
      "secondaryEmployment": "Empleo secundario",
      "socialSecurity": "Seguridad social",
      "supplementalSecurityIncome": "Ingreso suplementario de seguridad",
      "unknown": "Desconocido",
      "workmansCompensation": "Compensación por accidente laboral"
    },
    "previousEmploymentType": {
      "fullTime": "Tiempo completo",
      "partTime": "Medio tiempo",
      "selfEmployed": "Trabajo por cuenta propia",
      "military": "Militar",
      "student": "Estudiante",
      "homemaker": "Encargo de casa",
      "retired": "Retirado",
      "disability": "Disabilidad",
      "other": "Otro"
    },
    "residenceType": {
      "own": "Dueño",
      "rent": "Rentado",
      "other": "Otro",
      "unknown": "Desconocido"
    },
    "residenceDuration": {
      "moreThan2Years": "Más de 2 años",
      "lessThan2Years": "Menos de 2 años"
    },
    "employmentDuration": {
      "moreThan1Year": "Más de 1 año",
      "lessThan1Year": "Menos de 1 año"
    },
    "employmentStatus": {
      "employed": "Empleado",
      "unemployed": "Desempleado"
    },
    "employmentType": {
      "disability": "Disabilidad",
      "fullTime": "Tiempo completo",
      "homemaker": "Encargo de casa",
      "military": "Militar",
      "other": "Otro",
      "partTime": "Medio tiempo",
      "retired": "Retirado",
      "selfEmployed": "Cuenta propia",
      "student": "Estudiante"
    },
    "errorBoundary": {
      "title": "Algo salió mal de nuestra parte..",
      "subtitle": "Algo salió mal al intentar mostrar esta página.<0></0>Intente volver más tarde.",
      "dashboard": "Panel"
    },
    "dropzone": {
      "active": "Suelte los archivos aquí...",
      "fileInput": "Cargar documento",
      "inactive": "Haga clic aquí para <0>agregar un nuevo archivo<0>",
      "invalid": "Suelte los archivos aquí, algunos serán rechazados...",
      "rejectedFileDuplicate": "ya enviado",
      "rejectedFileType": "tipo de archivo incorrecto",
      "rejectedFileTooLarge": "archivo demasiado grande"
    },
    "rate": {
      "payment": "pago",
      "estimatedPayment": "est. pago*",
      "apr": "apr",
      "estimatedApr": "est. apr*",
      "term": "plazo",
      "monthlyPaymentAmount": "${{amount}}/mes",
      "aprPercent": "{{percent}}%",
      "termMonths": "{{months}} meses"
    },
    "mailCodeSavingsOffer": {
      "estOriginalPayment": "Est <0>original</0> pago",
      "estOriginalPaymentAmount": "${{amount}}/mes",
      "estRefinancePayment": "Est <0>refinance</0> pago",
      "estRefinancePaymentAmount": "${{amount}}/mes",
      "estSavings": "Est <0>ahorro</0> cantidad",
      "estSavingsAmount": "-${{amount}}/mes"
    },
    "banners": {
      "refandi": {
        "title": "Descubra más formas de ahorrar!",
        "subtitle": "Suba los documentos de su préstamo con el concesionario y descubra nuevas formas de ahorrar. En promedio, los clientes reciben más de $1,000 de reembolso al refinanciar.",
        "savingsAmount": "$1,000",
        "estSavings": "ahorro aprox.",
        "getStarted": "Comenzar",
        "disclaimer": "Protección proporcionada por The Savings Group, LLC"
      }
    },
    "NotFoundPage": {
      "title": "Lo sentimos, no pudimos encontrar esa página",
      "subtitle": "Es posible que haya sido eliminada o que el enlace esté roto. Regresemos\na la página principal, donde puedes gestionar tus aplicaciónes.",
      "returnHome": "Volver al inicio"
    },
    "SignInPage": {
      "title": "Bienvenido!",
      "subtitle": "Le enviaremos un código de verificación de seis dígitos para entrar a su cuenta.",
      "phoneNumber": "Número de teléfono",
      "continue": "Continuar",
      "noAccount": "No tienes una cuenta?",
      "signup": "Regístrar"
    },
    "SignInPinVerifyPage": {
      "title": "Ingrese el código de 6 dígitos",
      "subtitle": "Por favor ingresa el código que te enviamos por mensaje de texto a <0>{{phoneNumber}}</0>",
      "resendCode": "Reenviar código",
      "resendCodeDelay": "Reenviar {{delay}}s",
      "codeSent": "Nuevo código enviado!",
      "signup": "Regístrar"
    },
    "SignUpPage": {
      "title": {
        "default": "Encuentra opciones de financiamiento vehicular diseñadas para tus objetivos",
        "REFINANCE": "Descubre si podrías pagar menos, en minutos.",
        "PURCHASE": "Obtén una precalificación y compra tu próximo vehículo con confianza",
        "LEASE_BUYOUT": "Financia la compra de tu arrendamiento, sin complicaciones"
      },
      "subtitle": {
        "default": {
          "firstLine": "Rápido y sencillo, sin compromiso",
          "secondLine": "Compara ofertas de más de 150 prestamistas",
          "thirdLine": "Sin llamadas de spam, solo actualizaciones"
        },
        "REFINANCE": {
          "firstLine": "Rápido y sencillo, sin compromiso",
          "secondLine": "Compara ofertas de más de 150 prestamistas",
          "thirdLine": "Sin llamadas de spam, solo actualizaciones"
        },
        "PURCHASE": {
          "firstLine": "Ahorra tiempo en el concesionario",
          "secondLine": "Compara ofertas de más de 150 prestamistas",
          "thirdLine": "Sin llamadas de spam, solo actualizaciones"
        },
        "LEASE_BUYOUT": {
          "firstLine": "Firma tus documentos desde cualquier lugar",
          "secondLine": "Un asesor dedicado te guía en cada paso",
          "thirdLine": "Financiamiento disponible a nivel nacional"
        }
      },
      "submitButton": {
        "default": "Comenzar",
        "REFINANCE": "Verificar Mi Tasa",
        "PURCHASE": "Obtener Precalificación",
        "LEASE_BUYOUT": "Explorar Mis Opciones"
      },
      "refandiSubtitle": "Regístrese para ver ahorros potenciales, opciones de cobertura de reemplazo y administrar su reembolso. No se requiere obligación ni verificación de crédito.",
      "signin": "Iniciar sesión",
      "firstName": "Primer nombre",
      "lastName": "Apellido",
      "phone": "Teléfono",
      "email": "Correo Electronico"
    },
    "SignUpPinVerifyPage": {
      "title": "Ingrese el código de 6 dígitos",
      "subtitle": "Por favor ingresa el código que te enviamos por mensaje de texto a <0>{{phoneNumber}}</0>",
      "resendCode": "Reenviar código",
      "resendCodeDelay": "Reenviar {{delay}}s",
      "codeSent": "Nuevo código enviado!",
      "signup": "Regístrar"
    },
    "SignUpReturningUser": {
      "title": "Eres un usuario recurrente?",
      "subtitle": "Parece que ya hay una cuenta registrada con estos detalles. Haga clic a continuación para iniciar sesión.",
      "ownershipUnverifiedTitle": "Encontramos una cuenta existente",
      "ownershipUnverifiedSubtitle": "Hemos encontrado una cuenta asociada a este correo electrónico, pero aún no se ha activado. Para mantenerla segura, utilize el enlace de activación que te enviamos por correo electrónico en relación con tu aplicación. Revisa tus correos de entrada o la carpeta de spam.",
      "phone": "Teléfono",
      "email": "Correo Electronico",
      "back": "Regressar",
      "signin": "Iniciar sesión"
    },
    "SignOutPage": {
      "title": "Has cerrado sesión",
      "subtitle": "Le enviaremos un código de verificación de seis dígitos para entrar a su cuenta.",
      "phoneNumber": "Número de teléfono",
      "continue": "Continuar",
      "noAccount": "No tienes una cuenta?",
      "signup": "Regístrar"
    },
    "ActivationPage": {
      "titleFull": "Bienvenido {{firstName}},\nde {{displayLabel}}.",
      "titleNameOnly": "Bienvenido {{firstName}},\nactivemos tu cuenta.",
      "titleLabelOnly": "Bienvenido experto en ahorros,\nde {{displayLabel}}.",
      "titleDefault": "Bienvenido experto en ahorros,\nactivemos tu cuenta.",
      "subtitle": "Por favor, verifica tu número de teléfono, lo usarás para accesar tu cuenta.",
      "offerSubtitle": "Felicidades! Estás pre-calificado para la siguiente tasa:",
      "phoneNumber": "Número de teléfono",
      "agreeToFollowing": "Estoy de acuerdo con lo siguiente",
      "agreeToFollowingCoapplicant": "Yo y mi co-aplicante estamos de acuerdo con lo siguiente",
      "continue": "Continuar"
    },
    "ActivationPinVerifyPage": {
      "title": "Ingrese el código de 6 dígitos",
      "subtitle": "Por favor ingresa el código que te enviamos por mensaje de texto a <0>{{phoneNumber}}</0>",
      "resendCode": "Reenviar código",
      "resendCodeDelay": "Reenviar {{delay}}s",
      "codeSent": "Nuevo código enviado!"
    },
    "ApplicationUpdatePage": {
      "title": {
        "default": "Bienvenido de nuevo!",
        "withDisplayLabel": "Bienvenido de nuevo,\nde parte de {{displayLabel}}!"
      },
      "subtitle": {
        "default": "Inicia sesión para ver las actualizaciones de tu solicitud.",
        "WELCOME_BACK": "Inicia sesión para ver las actualizaciones de tu solicitud.",
        "HAS_APPROVAL": "Inicia sesión para ver las actualizaciones de tu solicitud.",
        "TERMS_UPDATED": "Los términos de tu préstamo de auto han sido actualizados. Por favor, inicia sesión para revisarlos.",
        "EDOCS_SIGNED": "Tus documentos electrónicos están completos y actualmente en revisión. Por favor, inicia sesión para revisarlos.",
        "LENDER_FUNDED": "Tu solicitud de préstamo ha sido aprobada y estamos en proceso de transferir el saldo de pago. Por favor, inicia sesión para revisarlo."
      },
      "phoneNumber": "Número de teléfono",
      "continue": "Continuar"
    },
    "MailCodePage": {
      "title": "Bienvenido a {{brand}},\npor favor ingresa tu <0>Código de ahorros</0>.",
      "subtitle": "Ingrese el <0>Código de ahorros</0> que recibió por correo para localizar su oferta de refinanciación personalizada.",
      "savingsId": "Código de ahorros",
      "continue": "Continuar",
      "missingSavingsId": "No tengo un código de ahorros"
    },
    "MailCodeOfferPage": {
      "title": {
        "SAVINGS": "{{firstName}}, estás precalificado para los siguientes descuentos!",
        "RATE": "{{firstName}}, estás precalificado para la siguiente oferta!"
      },
      "subtitle": "Ha sido preaprobado para un préstamo de hasta ${{amount}}.",
      "continue": "Continuar"
    },
    "MailCodeActivationPage": {
      "title": {
        "default": "Vamos a proteger tus ahorros.",
        "REFINANCE": "Vamos a proteger tus ahorros.",
        "PURCHASE": "Vamos a fijar tu tasa.",
        "LEASE_BUYOUT": "Vamos a fijar tu tasa."
      },
      "subtitle": {
        "default": "Simplemente añade tu número de teléfono y correo electrónico para crear tu cuenta y obtener tu oferta de refinanciación personalizada.",
        "REFINANCE": "Simplemente añade tu número de teléfono y correo electrónico para crear tu cuenta y obtener tu oferta de refinanciación personalizada.",
        "PURCHASE": "Simplemente añade tu número de teléfono y correo electrónico para crear tu cuenta y obtener tu oferta de compra personalizada.",
        "LEASE_BUYOUT": "Simplemente añade tu número de teléfono y correo electrónico para crear tu cuenta y obtener tu oferta de arrendamiento personalizada."
      },
      "firstName": "Primer nombre",
      "lastName": "Apellido",
      "phone": "Teléfono",
      "email": "Correo Electronico",
      "continue": "Continuar"
    },
    "MailCodePinVerifyPage": {
      "title": "Ingrese el código de 6 dígitos",
      "subtitle": "Por favor ingresa el código que te enviamos por mensaje de texto a <0>{{phoneNumber}}</0>",
      "resendCode": "Reenviar código",
      "resendCodeDelay": "Reenviar {{delay}}s",
      "codeSent": "Nuevo código enviado!"
    },
    "PreviewOfferPage": {
      "title": {
        "default": "Aquí para ofrecerte un mejor pago de auto.",
        "REFINANCE": "{{brand}} y {{displayLabel}} están trabajando juntos para ofrecerte un mejor pago de auto.",
        "PURCHASE": "{{brand}} y {{displayLabel}} están trabajando juntos para ayudarte a obtener financiamiento competitivo para la compra de tu vehículo.",
        "LEASE_BUYOUT": "{{brand}} y {{displayLabel}} se han asociado para hacer que comprar tu vehículo arrendado sea más fácil que nunca."
      },
      "subtitle": "Estás preaprobado hasta ${{amount}}",
      "continue": "Continuar",
      "disclaimer": "*La Tasa de Porcentaje Anual (APR), el pago mensual y las estimaciones del plazo del préstamo representan las tasas promedio disponibles entre los prestamistas de la red de The Savings Group en varios rangos de crédito. Estas tasas asumen una relación préstamo-valor minorista (LTV) de no más del 125% y una relación deuda-ingreso (DTI) de no más del 50%. Además del LTV y DTI individuales, el APR real que puede recibir depende de muchos factores evaluados al momento de la solicitud, que pueden incluir, entre otros, puntaje de crédito, monto del préstamo, plazo del préstamo, información del vehículo, uso e historial de crédito. Todos los préstamos están sujetos a revisión y aprobación de crédito. Los APR estimados pueden no estar disponibles en el área geográfica de su residencia. Si bien se han hecho esfuerzos para mantener información precisa, el APR estimado u otros términos presentados no comprometen a ningún prestamista. Los prestamistas generalmente tienen un rango de APR disponibles (por ejemplo, el rango de un prestamista podría ser del 2% al 24%) y solo los prestatarios con excelente crédito calificarán para la tasa más baja disponible."
    },
    "PreviewActivationPage": {
      "title": "Aseguremos tu tasa.",
      "subtitle": "Simplemente añade tu número de teléfono y correo electrónico para crear tu cuenta y obtener tu oferta personalizada.",
      "firstName": "Primer nombre",
      "lastName": "Apellido",
      "phone": "Teléfono",
      "email": "Correo Electronico",
      "continue": "Continuar"
    },
    "PreviewPinVerifyPage": {
      "title": "Ingrese el código de 6 dígitos",
      "subtitle": "Por favor ingresa el código que te enviamos por mensaje de texto a <0>{{phoneNumber}}</0>",
      "resendCode": "Reenviar código",
      "resendCodeDelay": "Reenviar {{delay}}s",
      "codeSent": "Nuevo código enviado!"
    },
    "DashboardGaragePage": {
      "title": {
        "default": "Bienvenido de nuevo.",
        "withName": "Bienvenido de nuevo, {{firstName}}."
      },
      "subtitle": "Selecciona una de tus aplicaciones para ver su estado y tus próximos pasos.",
      "newApplication": "Crear nueva",
      "empty": {
        "title": "No tienes aplicaciones...",
        "subtitle": "Haz clic en el botón de abajo para comenzar."
      },
      "refandi": {
        "description": "Continúa tu reembolso",
        "applicationDescription": "Descubre cuánto puedes ahorrar!"
      }
    },
    "DuplicateApplicationPage": {
      "title": "Buenas noticias. Ya estamos en ello.",
      "subtitle": "Parece que ya enviaste una solicitud para tu {{vehicle}} y nuestro equipo ya está trabajando en ella. Para evitar procesarla dos veces, continuaremos con tu solicitud original y guardaremos este envío como referencia. Si algo ha cambiado o tienes preguntas, comunícate con tu especialista de préstamos.",
      "brandChangeTitle": "Ya estás en buenas manos.",
      "brandChangeSubtitle": "Parece que ya tienes una solicitud activa para tu {{vehicle}} con una de nuestras otras marcas. Como {{duplicateBrand}} y {{activeBrand}} forman parte de The Savings Group, tendrás acceso a la misma gran red de prestamistas y al mismo servicio al cliente sin importar con qué marca trabajes.",
      "notice": "No necesitas hacer nada más. Continuaremos procesando tu solicitud existente y guardaremos este envío como referencia.",
      "account": "Ir a mi cuenta",
      "defaultVehicle": "vehículo"
    },
    "DashboardApplicationPage": {
      "progress": "Progreso",
      "viewAll": "Ver todo",
      "noInformationAvailable": "No hay información disponible",
      "contact": "Contact",
      "name": "Nombre",
      "phone": "Número de teléfono",
      "email": "Correo Electronico",
      "otherWaysToSave": "Otras formas de ahorrar"
    },
    "ApplyPage": {
      "title": "Bienvenido {{firstName}}.\nComencemos con tu aplicación.",
      "subtitle": "Proporcione los detalles de su vehículo para ayudarnos a ofrecerle las mejores opciones de financiamiento adaptadas a sus necesidades.",
      "continue": "Continuar",
      "resume": "Resumir"
    },
    "ApplyApplicationTypePage": {
      "title": "Comencemos",
      "subtitle": "Para comenzar, escoge el tipo de financiamiento de vehículo que mejor se adapte a tus necesidades.",
      "continue": "Continuar",
      "refinance": "Refinanciar",
      "leaseBuyout": "Compra de arrendamiento",
      "purchase": "Comprar"
    },
    "ApplyRefinanceGoalPage": {
      "title": "Establece tu objetivo de refinanciamiento",
      "subtitle": "Dinos qué deseas lograr con tu refinanciamiento para ayudarte a encontrar las mejores opciones.",
      "continue": "Continuar",
      "lowerPayment": "Pago más bajo",
      "lowerRate": "Tarifa más baja",
      "checkingOptions": "Chequiando mis opciones"
    },
    "ApplyPurchaseTypePage": {
      "title": "Selecciona el tipo de compra",
      "subtitle": "Escoge si comprarás en un concesionario o a un vendedor particular para continuar.",
      "continue": "Continuar",
      "dealer": "Concesionario",
      "privateParty": "Vendedor privado"
    },
    "ApplyVehicleConditionPage": {
      "title": "Selecciona la condición del vehículo",
      "subtitle": "Indica si estás comprando un vehículo nuevo o usado para ayudarnos a personalizar tus opciones de financiamiento.",
      "continue": "Continuar",
      "new": "Nuevo",
      "used": "Usado"
    },
    "ApplyVehicleSelectionPage": {
      "title": "Selecciona de sus vehículos",
      "subtitle": "Selecciona el vehículo que deseas refinanciar de la lista a continuación, o haz clic en el botón en la parte de abajo para ingresarlo manualmente.",
      "continue": "Continuar",
      "enterManually": "No veo mi vehículo"
    },
    "ApplySearchVehiclePage": {
      "title": "Vamos a encontrar tu vehículo",
      "subtitle": "Dinos cómo te gustaría buscar tu vehículo para comenzar.",
      "continue": "Continuar",
      "byVin": "Por VIN",
      "byLicensePlate": "Por placa",
      "byMakeModel": "Por marca y modelo"
    },
    "ApplySearchVinPage": {
      "title": "Ingresa el VIN de tu vehículo",
      "subtitle": "Proporciona tu Número de Identificación del Vehículo (VIN) para ayudarnos a localizar tu auto.",
      "continue": "Continuar",
      "searching": "Buscando",
      "vin": "VIN"
    },
    "ApplySearchPlatePage": {
      "title": "Ingresa la placa de tu vehículo",
      "subtitle": "Proporciona la información de tu placa para ayudarnos a localizar tu auto.",
      "continue": "Continuar",
      "searching": "Buscando",
      "plate": "Placa",
      "state": "Estado"
    },
    "ApplySearchYearPage": {
      "title": "Selecciona el año de tu vehículo",
      "subtitle": "Escoge el año de tu vehículo para reducir la búsqueda.",
      "continue": "Continuar"
    },
    "ApplySearchMakePage": {
      "title": "Selecciona la marca de tu vehículo",
      "subtitle": "Escoge la marca de tu vehículo para continuar con la búsqueda.",
      "continue": "Continuar"
    },
    "ApplySearchModelPage": {
      "title": "Selecciona el modelo de tu vehículo",
      "subtitle": "Escoge el modelo de tu vehículo para completar la búsqueda.",
      "continue": "Continuar"
    },
    "ApplyConfirmVehiclePage": {
      "subtitle": "Verifica los detalles de tu vehículo y proporciona la información restante para continuar con tu aplicación.",
      "trim": "Versión de modelo",
      "mileage": "Millaje estimado",
      "payoffAmount": "Pago restante estimado",
      "purchasePrice": "Precio de compra estimado",
      "continue": "Continuar"
    },
    "ApplicantPage": {
      "title": "Veamos si hay ahorros en tu {{vehicle}}.",
      "subtitle": "Necesitamos colectar algunos detalles adicionales para ofrecerte la más amplia gama de opciones de financiamiento adaptadas a tus necesidades.",
      "continue": "Continuar"
    },
    "ApplicantResidenceTypePage": {
      "title": "Selecciona tu tipo de residencia",
      "subtitle": "Escoge el tipo de residencia que mejor describa tu situación de vivienda actual.",
      "continue": "Continue",
      "own": "Dueño",
      "rent": "Rentado",
      "other": "Otro"
    },
    "ApplicantResidenceDetailsPage": {
      "title": "Ingresa los detalles de tu residencia",
      "subtitle": "Proporciona tu dirección y la parte del pago de vivienda de la que solo tú eres responsable.",
      "continue": "Continuar",
      "housingAmount": "Cantidad de vivienda",
      "residenceLineOne": "Dirección",
      "residenceLineTwo": "Apt, Unidad",
      "residenceCity": "Ciudad",
      "residenceState": "Estado",
      "zip": "Código Postal"
    },
    "ApplicantResidenceDurationPage": {
      "title": "Has vivido aquí por más de dos años?",
      "subtitle": "Si has vivido en tu dirección actual por menos de dos años, necesitaremos los detalles de tu residencia anterior.",
      "yes": "Si",
      "no": "No",
      "continue": "Continuar"
    },
    "ApplicantPreviousResidencePage": {
      "title": "Ingresa los detalles de tu residencia anterior",
      "subtitle": "Proporciona tu dirección anterior y otros detalles para ayudarnos a verificar tu residencia previa.",
      "continue": "Continuar",
      "residenceLineOne": "Dirección",
      "residenceLineTwo": "Apt, Unidad",
      "residenceCity": "Ciudad",
      "residenceState": "Estado",
      "zip": "Código Postal"
    },
    "ApplicantEmploymentStatusPage": {
      "title": "Selecciona tu estado de empleo",
      "subtitle": "Elige si actualmente estás empleado o no para ayudarnos a entender tu situación financiera.",
      "yes": "Empleado",
      "no": "No empleado",
      "continue": "Continuar"
    },
    "ApplicantEmploymentTypePage": {
      "title": "Especifica tu tipo de empleo",
      "subtitle": "Indica la opción que mejor describa tu situación financiera. Si tienes ingresos adicionales, podrás declararlos en los siguientes pasos.",
      "fullTime": "Tiempo completo",
      "partTime": "Medio tiempo",
      "selfEmployed": "Cuenta propia",
      "military": "Militar",
      "continue": "Continuar"
    },
    "ApplicantUnemploymentTypePage": {
      "title": "Especifica tu tipo de empleo",
      "subtitle": "Indica la opción que mejor describe tu situación financiera. Si tienes ingresos adicionales, podrás declararlos en los siguientes pasos.",
      "disability": "Disabilidad",
      "homemaker": "Encargo de casa",
      "retired": "Retirado",
      "student": "Estudiante",
      "other": "Otro",
      "continue": "Continuar"
    },
    "ApplicantEmploymentDetailsPage": {
      "title": "Ingresa los detalles de tu empleo",
      "subtitle": "Proporciona información sobre tu empleador, cargo y salario para ayudarnos a comprender mejor tu situación financiera.",
      "employerName": "Nombre del empleador",
      "jobTitle": "Título profesional",
      "grossAnnualIncome": "Ingreso anual bruto",
      "continue": "Continuar"
    },
    "ApplicantUnemploymentDetailsPage": {
      "title": "Ingresa tu ingreso actual",
      "subtitle": "Proporciona información sobre tu ingreso para ayudarnos a comprender mejor tu situación financiera.",
      "grossAnnualIncome": "Ingreso anual bruto",
      "continue": "Continuar"
    },
    "ApplicantEmploymentDurationPage": {
      "title": "Has trabajado aquí por más de un año?",
      "subtitle": "Si has trabajado en tu empleador actual por menos de un año, necesitaremos los detalles de tu empleo anterior.",
      "yes": "Si",
      "no": "No",
      "continue": "Continuar"
    },
    "ApplicantPreviousEmploymentPage": {
      "title": "Proporciona tu empleo anterior",
      "subtitle": "Proporciona los detalles de tu empleo anterior y otra información para ayudarnos a verificarlo.",
      "employmentType": "Tipo de empleo",
      "employerName": "Nombre del empleador",
      "jobTitle": "Título profesional",
      "grossAnnualIncome": "Ingreso anual bruto",
      "continue": "Continuar"
    },
    "ApplicantAdditionalIncomePage": {
      "title": "Tienes ingresos adicionales?",
      "subtitle": "Dinos si tienes fuentes de ingresos adicionales para ayudarnos a comprender mejor tu situación financiera.",
      "yes": "Si",
      "no": "No",
      "continue": "Continuar"
    },
    "ApplicantAddCoapplicantPage": {
      "title": "¿Agregar un Co-aplicante?",
      "subtitle": "Incluye un co-aplicante para fortalecer tu solicitud y mejorar tus posibilidades de aprobación.",
      "yes": "Si",
      "no": "No",
      "continue": "Continuar"
    },
    "ApplicantIncomeDetailsPage": {
      "title": "Proporciona los detalles de tus ingresos",
      "subtitle": "Ingresa los detalles de tus ingresos adicionales para asegurarnos de tener una imagen completa de tus finanzas.",
      "incomeType": "Tipo de ingreso",
      "incomeFrequency": "Frecuencia de ingreso",
      "incomeAmount": "Cantidad de ingreso",
      "employerName": "Nombre del empleador",
      "jobTitle": "Título del trabajo",
      "durationMonths": "Meses en",
      "durationYears": "Años en",
      "continue": "Continuar"
    },
    "ApplicantEditPersonalPage": {
      "title": "Edita tus detalles personales",
      "subtitle": "Actualiza tu información personal si hay cambios o correcciones necesarias.",
      "firstName": "Primer Nombre",
      "lastName": "Apellido",
      "phone": "Teléfono",
      "email": "Correo Electronico",
      "cancel": "Cancelar",
      "save": "Guardar"
    },
    "ApplicantEditResidencePage": {
      "title": "Edita los detalles de tu residencia",
      "subtitle": "Realiza cualquier actualización necesaria en tu información de residencia para mantenerla actualizada.",
      "housingType": "Tipo de vivienda",
      "housingAmount": "Cantidad de vivienda",
      "residenceLineOne": "Dirección",
      "residenceLineTwo": "Apt, Unidad",
      "residenceCity": "Ciudad",
      "residenceState": "Estado",
      "zip": "Código Postal",
      "duration": "Duración",
      "previousResidence": "Residencia anterior",
      "cancel": "Cancelar",
      "save": "Guardar"
    },
    "ApplicantEditEmploymentPage": {
      "title": "Edita los detalles de tu empleo",
      "subtitle": "Revisa y actualiza tu información de empleo para asegurarte de que sea precisa.",
      "employmentStatus": "Estatus de empleo",
      "type": "Tipo",
      "employerName": "Nombre del empleador",
      "jobTitle": "Título profesional",
      "grossAnnualIncome": "Ingreso anual bruto",
      "duration": "Duración",
      "previousEmployment": "Empleo anterior",
      "cancel": "Cancelar",
      "save": "Guardar"
    },
    "ApplicantEditIncomePage": {
      "title": "Edita los detalles de tus ingresos",
      "subtitle": "Proporciona cualquier actualización sobre tu información de ingresos para reflejar tu situación financiera actual.",
      "incomeType": "Tipo de ingreso",
      "incomeFrequency": "Frecuencia de ingreso",
      "additionalIncome": "Ingresos adicionale",
      "incomeAmount": "Cantidad de ingreso",
      "employerName": "Nombre del empleador",
      "jobTitle": "Título del trabajo",
      "durationMonths": "Meses en",
      "durationYears": "Años en",
      "cancel": "Cancelar",
      "save": "Guardar"
    },
    "ApplicantReviewPage": {
      "title": "Revisa los detalles de tu aplicación",
      "subtitle": "Tómate un momento para revisar toda la información que has proporcionado y asegurarte de su precisión.",
      "personal": "Personal",
      "residence": "Residencia",
      "employment": "Empleo",
      "income": "Ingresos",
      "additionalIncome": "Ingresos adicionale",
      "firstName": "Primer nombre",
      "lastName": "Apellido",
      "phone": "Teléfono",
      "email": "Correo electrónico",
      "type": "Tipo",
      "address": "Dirección",
      "amount": "Cantidad",
      "duration": "Duración",
      "status": "Estatus",
      "frequency": "Frecuencia",
      "edit": "Editar",
      "continue": "Continuar"
    },
    "ApplicantSubmitPage": {
      "title": "Finaliza y envía tu aplicación",
      "subtitle": "Confirma todos tus detalles y envía tu aplicación para completar el proceso.",
      "coapplicant": "Co-aplicante",
      "dateOfBirth": "Fecha de nacimiento",
      "socialSecurityNumber": "Número de Seguro Social (opcional)",
      "ssnDescription": "Proporcionar tu Número de Seguro Social ahora agiliza el proceso y nos ayuda a asegurar las tarifas más precisas. Toda la información está cifrada de forma segura.",
      "coapplicantSsnDescription": "Proporcionar su Número de Seguro Social ahora agiliza el proceso y nos ayuda a asegurar las tarifas más precisas. Toda la información está cifrada de forma segura.",
      "agreeToFollowing": "Estoy de acuerdo con lo siguiente:",
      "agreeToFollowingCoapplicant": "Yo y el co-aplicante estamos de acuerdo con lo siguiente:",
      "submit": "Submitir"
    },
    "ApplicantSuccessPage": {
      "title": "¡Tu aplicación se envió con éxito!",
      "subtitle": "Mientras revisamos tu aplicación, continúa subiendo los documentos de verificación requeridos para avanzar en el proceso.",
      "dashboard": "Panel"
    },
    "CoapplicantRelationshipPage": {
      "title": "Especifica tu relación con el aplicante",
      "subtitle": "Indica la relación entre tú y el co-aplicante para ayudarnos a comprender su conexión.",
      "spouse": "Esposo/Esposa",
      "relative": "Familiar",
      "friend": "Amigo",
      "coworker": "Compañero de trabajo",
      "other": "Otro",
      "continue": "Continuar"
    },
    "CoapplicantPersonalDetailsPage": {
      "title": "Ingresa sus detalles personales",
      "subtitle": "Proporciona la información personal del co-aplicante para continuar con tu aplicación.",
      "firstName": "Primer Nombre",
      "lastName": "Apellido",
      "phone": "Teléfono",
      "email": "Correo Electronico",
      "continue": "Continuar"
    },
    "CoapplicantResidenceRelationshipPage": {
      "title": "Viven con el aplicante?",
      "subtitle": "Indica si ambos viven en la misma residencia para ayudarnos a comprender su situación de vivienda y agilizar los siguientes pasos.",
      "yes": "Si",
      "no": "No",
      "continue": "Continuar"
    },
    "CoapplicantSameResidencePage": {
      "title": "Ingrese los detalles de su residencia",
      "subtitle": "Proporcione la parte del pago de vivienda de la que solo el co-aplicante es responsable.",
      "coapplicantHousingAmount": "Co-aplicante cantidad de vivienda",
      "continue": "Continue"
    },
    "CoapplicantDifferentResidenceTypePage": {
      "title": "Seleccione su tipo de residencia",
      "subtitle": "Elija el tipo de residencia que mejor describa su situación de vivienda actual.",
      "continue": "Continue",
      "own": "Dueño",
      "rent": "Rentado",
      "other": "Otro"
    },
    "CoapplicantDifferentResidencePage": {
      "title": "Ingrese los detalles de su residencia",
      "subtitle": "Proporcione su dirección y la parte del pago de vivienda de la que solo el co-aplicante es responsable.",
      "continue": "Continuar",
      "housingAmount": "Co-aplicante cantidad de vivienda",
      "residenceLineOne": "Dirección",
      "residenceLineTwo": "Apt, Unidad",
      "residenceCity": "Ciudad",
      "residenceState": "Estado",
      "zip": "Código Postal"
    },
    "CoapplicantResidenceDurationPage": {
      "title": "Han vivido aquí por más de dos años?",
      "subtitle": "Si han vivido en su dirección actual por menos de dos años, necesitaremos los detalles de su residencia anterior.",
      "yes": "Si",
      "no": "No",
      "continue": "Continuar"
    },
    "CoapplicantPreviousResidencePage": {
      "title": "Ingrese los detalles de la residencia anterior",
      "subtitle": "Proporcione su dirección anterior y otros detalles para ayudarnos a verificar su residencia previa.",
      "continue": "Continuar",
      "residenceLineOne": "Dirección",
      "residenceLineTwo": "Apt, Unidad",
      "residenceCity": "Ciudad",
      "residenceState": "Estado",
      "zip": "Código Postal"
    },
    "CoapplicantEmploymentStatusPage": {
      "title": "Seleccione su estado de empleo",
      "subtitle": "Elige si actualmente están empleado o no para ayudarnos a entender su situación financiera.",
      "yes": "Empleado",
      "no": "No empleado",
      "continue": "Continuar"
    },
    "CoapplicantEmploymentTypePage": {
      "title": "Especifique su tipo de empleo",
      "subtitle": "Indique la opción que mejor describa su situación financiera. Si tienen ingresos adicionales, pueden declararlos en los próximos pasos.",
      "fullTime": "Tiempo completo",
      "partTime": "Medio tiempo",
      "selfEmployed": "Cuenta propia",
      "military": "Militar",
      "continue": "Continuar"
    },
    "CoapplicantUnemploymentTypePage": {
      "title": "Especifique su tipo de empleo",
      "subtitle": "Indique la opción que mejor describa su situación financiera. Si obtiene ingresos adicionales, puede declararlos en los próximos pasos.",
      "disability": "Disabilidad",
      "homemaker": "Encargo de casa",
      "retired": "Retirado",
      "student": "Estudiante",
      "other": "Otro",
      "continue": "Continuar"
    },
    "CoapplicantEmploymentDetailsPage": {
      "title": "Ingrese los detalles de su empleo",
      "subtitle": "Proporcione información sobre su empleador, cargo y ingresos para ayudarnos a comprender mejor su situación financiera.",
      "employerName": "Nombre del empleador",
      "jobTitle": "Título profesional",
      "grossAnnualIncome": "Ingreso anual bruto",
      "continue": "Continuar"
    },
    "CoapplicantUnemploymentDetailsPage": {
      "title": "Ingrese sus ingresos actuales",
      "subtitle": "Proporcione información sobre sus ingresos para ayudarnos a comprender mejor su situación financiera.",
      "grossAnnualIncome": "Ingreso anual bruto",
      "continue": "Continuar"
    },
    "CoapplicantEmploymentDurationPage": {
      "title": "Han trabajado aquí por más de un año?",
      "subtitle": "Si han trabajado en su empleador actual por menos de un año, necesitaremos los detalles de su empleo anterior.",
      "yes": "Si",
      "no": "No",
      "continue": "Continuar"
    },
    "CoapplicantPreviousEmploymentPage": {
      "title": "Proporcione su empleo anterior",
      "subtitle": "Proporcione su empleo anterior y otros detalles para ayudarnos a verificar su historial laboral.",
      "employmentType": "Tipo de empleo",
      "employerName": "Nombre del empleador",
      "jobTitle": "Título profesional",
      "grossAnnualIncome": "Ingreso anual bruto",
      "continue": "Continuar"
    },
    "CoapplicantAdditionalIncomePage": {
      "title": "Tienen ingresos adicionales?",
      "subtitle": "Háganos saber si tienen alguna fuente adicional de ingresos para ayudarnos a comprender mejor su situación financiera.",
      "yes": "Si",
      "no": "No",
      "continue": "Continuar"
    },
    "CoapplicantIncomeDetailsPage": {
      "title": "Proporcione los detalles de sus ingresos",
      "subtitle": "Ingrese los detalles de sus ingresos adicionales para asegurarnos de tener una imagen completa de sus finanzas.",
      "incomeType": "Tipo de ingreso",
      "incomeFrequency": "Frecuencia de ingreso",
      "incomeAmount": "Cantidad de ingreso",
      "employerName": "Nombre del empleador",
      "jobTitle": "Título del trabajo",
      "durationMonths": "Meses en",
      "durationYears": "Años en",
      "continue": "Continuar"
    },
    "CoapplicantEditPersonalPage": {
      "title": "Editar sus detalles personales",
      "subtitle": "Actualice su información personal si hay cambios o correcciones necesarias.",
      "firstName": "Primer Nombre",
      "lastName": "Apellido",
      "phone": "Teléfono",
      "email": "Correo Electronico",
      "cancel": "Cancelar",
      "save": "Guardar"
    },
    "CoapplicantEditResidencePage": {
      "title": "Editar sus detalles de residencia",
      "subtitle": "Realice las actualizaciones necesarias en su información de residencia para mantenerla actualizada.",
      "housingType": "Tipo de vivienda",
      "housingAmount": "Cantidad de vivienda",
      "residenceLineOne": "Dirección",
      "residenceLineTwo": "Apt, Unidad",
      "residenceCity": "Ciudad",
      "residenceState": "Estado",
      "zip": "Código Postal",
      "duration": "Duración",
      "previousResidence": "Residencia anterior",
      "cancel": "Cancelar",
      "save": "Guardar"
    },
    "CoapplicantEditEmploymentPage": {
      "title": "Editar sus detalles de empleo",
      "subtitle": "Revise y actualice su información de empleo para asegurarse de que sea precisa.",
      "employmentStatus": "Estatus de empleo",
      "type": "Tipo",
      "employerName": "Nombre del empleador",
      "jobTitle": "Título profesional",
      "grossAnnualIncome": "Ingreso anual bruto",
      "duration": "Duración",
      "previousEmployment": "Empleo anterior",
      "cancel": "Cancelar",
      "save": "Guardar"
    },
    "CoapplicantEditIncomePage": {
      "title": "Editar sus detalles de ingresos",
      "subtitle": "Proporcione cualquier actualización de su información de ingresos para reflejar su situación financiera actual.",
      "incomeType": "Tipo de ingreso",
      "incomeFrequency": "Frecuencia de ingreso",
      "additionalIncome": "Ingresos adicionale",
      "incomeAmount": "Cantidad de ingreso",
      "employerName": "Nombre del empleador",
      "jobTitle": "Título del trabajo",
      "durationMonths": "Meses en",
      "durationYears": "Años en",
      "cancel": "Cancelar",
      "save": "Guardar"
    },
    "CoapplicantReviewPage": {
      "title": "Revisar los detalles de su aplicación",
      "subtitle": "Tómese un momento para revisar toda la información proporcionada y asegurarse de su exactitud.",
      "personal": "Personal",
      "residence": "Residencia",
      "employment": "Empleo",
      "income": "Ingresos",
      "additionalIncome": "Ingresos adicionale",
      "firstName": "Primer nombre",
      "lastName": "Apellido",
      "phone": "Teléfono",
      "email": "Correo electrónico",
      "type": "Tipo",
      "address": "Dirección",
      "amount": "Cantidad",
      "duration": "Duración",
      "status": "Estatus",
      "frequency": "Frecuencia",
      "edit": "Editar",
      "continue": "Continuar"
    },
    "LoanDocumentPage": {
      "title": "Bienvenido, {{firstName}}!",
      "subtitle": "Si compró un Contrato de Servicio para Vehículos o una póliza de GAP en su concesionario, es muy probable que podamos ahorrarle dinero en sus productos de protección y proporcionarle miles en reembolsos.",
      "continue": "Continuar",
      "resume": "Resumir"
    },
    "LoanDocumentListPage": {
      "continue": "Continuar",
      "edit": "Editar",
      "gap": "Contrato de GAP",
      "numberOfDocs_one": "{{count}} documento",
      "numberOfDocs_other": "{{count}} documentos",
      "numberOfDocs_zero": "{{count}} documentos",
      "ric": "Contrato de compra a plazos",
      "subtitle": "Estos documentos están incluidos en su paquete de préstamo que recibió de su concesionario. Si no puede localizarlos, contacte a su concesionario para solicitar una copia de sus documentos de préstamo.",
      "tapToUpload": "Toque para cargar",
      "title": "Subir Documentos de Protección",
      "upload": "Subir",
      "uploadFailed": "Fallo en la solicitud de carga. Intente nuevamente más tarde.",
      "uploadTimeout": "Tiempo de espera de la solicitud agotado. Por favor, verifique su conexión y intente nuevamente.",
      "vsc": "Contrato de servicio"
    },
    "LoanDocumentUploadPage": {
      "exampleDocument": "Documento de ejemplo",
      "cancel": "Cancelar",
      "tooltip": "Si no está seguro de tener el documento correcto o tiene varios documentos, súbalos todos y nosotros encontraremos el documento apropiado.",
      "remove": "Eliminar",
      "submit": "Submitir",
      "uploaded": "Ya cargado"
    },
    "LoanDocumentUploadRICPage": {
      "title": "Contrato de compra a plazos",
      "subtitle": "Este documento suele tener entre 4 y 5 páginas y detalla los términos del préstamo/financiamiento de su préstamo para automóvil. Generalmente, las páginas uno y dos son las más importantes."
    },
    "LoanDocumentUploadGAPPage": {
      "title": "Contrato de GAP",
      "subtitle": "Este documento suele tener varias páginas y detalla información sobre usted, su vehículo, el acreedor y los términos de la póliza. Una copia legible de la primera página es la más importante."
    },
    "LoanDocumentUploadVSCPage": {
      "title": "Contrato de servicio",
      "subtitle": "Este documento suele tener varias páginas y detalla información sobre usted, su vehículo, el acreedor y la cobertura de su contrato de servicio (millaje, plazo, etc.)."
    },
    "LoanDocumentUploadAllPage": {
      "exampleDocumentsTitle": "Documento de ejemplo:",
      "exampleGAPDocument": "documento GAP",
      "exampleRICDocument": "documento RIC",
      "exampleVSCDocument": "documento VSC",
      "submit": "Submitir",
      "subtitle": "Sube tus documentos de préstamo / vendedor, analizaremos tu oferta y te daremos un informe personalizado detallando tus ahorros con la cantidad de reembolso elegibles.",
      "subtitleToo": "No estás seguro de qué tienes? No hay problema, sube lo que tengas y nosotros lo resolveremos por ti.",
      "title": "Ahorros así de simples."
    },
    "LoanDocumentMileagePage": {
      "mileage": "Millaje",
      "submit": "Submitir",
      "subtitle": "Por favor, proporcione el millaje actual del vehículo, ya que ayudará a determinar el monto del reembolso que le corresponde.",
      "title": "Millaje actual del vehículo"
    },
    "LoanDocumentSuccessPage": {
      "title": "¡Sus documentos se enviaron correctamente!",
      "subtitle": "Siéntese y relájese mientras buscamos ahorros. Esté atento a su Informe de Ahorros!",
      "submit": "Enviar"
    },
    "VerificationPage": {
      "title": "Recopilemos sus documentos de verificación requeridos",
      "subtitle": "Esto nos ayudará a verificar la exactitud de la información de su aplicación y agilizar los siguientes pasos en la financiación de su solicitud.",
      "continue": "Continuar"
    },
    "VerificationDocumentListPage": {
      "title": "Subir documentos de verificación",
      "subtitle": "Sube todos y cada uno de los documentos requeridos para verificar su información y completar su solicitud."
    },
    "VerificationUploadPage": {
      "required": "Requerido",
      "edit": "Editar",
      "upload": "Subir",
      "cancel": "Cancelar",
      "submit": "Submitir",
      "uploadFailed": "Fallo en la solicitud de carga. Intente nuevamente más tarde.",
      "uploadTimeout": "Tiempo de espera de la solicitud agotado. Por favor, verifique su conexión y intente nuevamente."
    },
    "VehicleConfirmationPage": {
      "title": "Confirmar detalles del vehículo",
      "subtitle": "Para ofrecerte las tarifas más precisas, por favor confirma que tenemos los detalles correctos del vehículo.",
      "selectYear": "Seleccionar año",
      "selectMake": "Seleccionar marca",
      "selectModel": "Seleccionar modelo",
      "selectTrim": "Seleccionar versión",
      "confirm": "Confirmar"
    }
  }
}
